import {
    LOGIN_API,
    LOGIN_BY_CODE_API,
    QR_CODE_API,
    QR_CODE_STATE_API,
    REGISTER_API
} from '@constants/api';
import _axios from '@plugins/_axios';

/**
 * 通过账号密码登录
 * @param {String} cellphone 手机号码
 * @param {String} password 密码
 * @param {Number} role 角色
 */
export function login(cellphone, password, role = 1) {
    return _axios.post(LOGIN_API, {
        cellphone,
        password,
        role
    });
}

/**
 * 通过验证码登录
 * @param {String} cellphone 手机号码
 * @param {String} code 验证码
 * @param {Number} role 角色
 */
export function loginByCode(cellphone, code, role = 1) {
    return _axios.post(LOGIN_BY_CODE_API, {
        cellphone,
        code,
        role
    });
}

/**
 * 获取二维码
 */
export function getQrcode() {
    return _axios.get(QR_CODE_API);
}

/**
 * 二维码状态检测
 */
export function getQrcodeState(uuid) {
    return _axios.get(QR_CODE_STATE_API + uuid);
}

/**
 * 注册
 * @param {String} cellphone 手机号
 * @param {String} code 手机验证码
 * @param {String} password 密码
 * @param {String} name 姓名
 * @param {String} school 学校名称
 * @param {String} grade 年级
 */
export function register({ cellphone, code, password, name, school, grade }) {
    return _axios.post(REGISTER_API, {
        cellphone,
        code,
        password,
        name,
        school,
        grade
    });
}
